import {
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { CoreState } from '../reducers/core.reducer';

const coreState = createFeatureSelector<CoreState>('core');

export const getSomethingWentWrongModalOpen = createSelector(
  coreState,
  (state) => state.somethingWentWrongModalOpen,
);

export const getExamReference = createSelector(
  coreState,
  (state) => state.examReference,
);

export const getIsInstallAppWhatNextModalOpen = createSelector(
  coreState,
  (state) => state.installAppWhatNextModalOpen,
);

export const getAppNotDetectedModalOpen = createSelector(
  coreState,
  (state) => state.appNotDetectedModalOpen,
);

export const getGoBackToLMSModalOpen = createSelector(
  coreState,
  (state) => state.goBackToLMSModalOpen,
);

export const getInvalidExamTokenModalOpen = createSelector(
  coreState,
  (state) => state.invalidExamTokenModalOpen,
);

export const getUnsupportedOperatingSystemModalOpen = createSelector(
  coreState,
  (state) => state.unsupportedOperatingSystemModalOpen,
);

export const getChooseYourInstallerModalOpen = createSelector(
  coreState,
  (state) => state.chooseYourInstallerModalOpen,
);
